import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './app/App';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const children = (
  <Router>
    <React.StrictMode>
      <App />
    </React.StrictMode>
   </Router>
);

const container = document.getElementById('root')

createRoot(container as Element).render(children)

reportWebVitals()
